<template>
  <v-form @submit.prevent="updateRunner" novalidate>
    <v-toolbar flat dense dark color="primary">
      <v-toolbar-title>SPRZĘTOWE</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="accent" small v-if="isActiveRunner || isAdmin" @click.prevent="updateMode = !updateMode">edytuj</v-btn>
    </v-toolbar>
    <v-layout row wrap>
      <v-flex xs12 sm6 md5 lg4 offset-sm6 offset-md4 offset-lg3>
        <v-list two-line>
          <runner-data-field
            :editable="updateMode"
            label="Zegarek z funkcją GPS"
            v-model="form.gps_watch"
            :objValue="runner.gps_watch ? 'TAK' : 'NIE'"
            :formErrors="formErrors"
            :field="'gps_watch'">

            <v-switch
              :label="`Zegarek z funkcją GPS: ${form.gps_watch ? 'TAK' : 'NIE'}`"
              v-model="form.gps_watch"
            ></v-switch>
          </runner-data-field>

          <runner-data-field
            :editable="updateMode"
            label="Zegarek z funkcją mierzenia tętna"
            v-model="form.pulse_watch"
            :objValue="runner.pulse_watch ? 'TAK' : 'NIE'"
            :formErrors="formErrors"
            :field="'pulse_watch'">

            <v-switch
              :label="`Zegarek z funkcją mierzenia tętna: ${form.pulse_watch ? 'TAK' : 'NIE'}`"
              v-model="form.pulse_watch"
            ></v-switch>
          </runner-data-field>

          <runner-data-field
            :editable="updateMode"
            label="Marka i model zegarka"
            v-model="form.watch_model"
            :objValue="runner.watch_model"
            :formErrors="formErrors"
            :field="'watch_model'"></runner-data-field>
          <runner-data-field
            :editable="updateMode"
            label="Marka i model butów biegowych"
            v-model="form.shoes_model"
            :objValue="runner.shoes_model"
            :formErrors="formErrors"
            :field="'shoes_model'"></runner-data-field>
        </v-list>
        <v-btn v-if="updateMode" type="submit" color="primary">Zapisz</v-btn>
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script>
import {updateRunnerData} from './api'
import iziToast from 'izitoast'
import { mapGetters } from 'vuex'
import RunnerDataField from './RunnerDataField'

export default {
  components: {RunnerDataField},
  validators: {},
  props: {
    runner: {
      type: Object
    }
  },
  data () {
    return {
      updateMode: false,
      form: {},
      formErrors: {}
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'isActiveRunner'])
  },
  created () {
    this.form = {...this.runner}
  },
  watch: {
    'runner': function (oldVar, newVar) {
      this.form = {...this.runner}
    }
  },
  methods: {
    updateRunner () {
      this.$validate().then(success => {
        if (success) {
          updateRunnerData(this.form).then((data) => {
            this.validation.reset()
            this.$emit('runner-updated', data)
            iziToast.show({
              message: 'Konto zawodnika zostało edytowane.',
              color: 'green'
            })
            this.updateMode = false
            return data
          }).catch((data) => {
            if (data.response.status === 400) {
              this.formErrors = data.response.data
              this.$validate()
            }
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/runners/RunnerDataGear.vue